import { __makeTemplateObject } from "tslib";
import { css, spacing } from '../../../../foundation';
import { RcStepClasses } from '../utils';
var stepPadding = spacing(4);
export var StepStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &.", " {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n  "], ["\n    &.", " {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n  "])), RcStepClasses.horizontal, stepPadding, stepPadding);
};
var templateObject_1;
